/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HazardCategoryDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: HazardCategoryDefinitionDto.source;
    label?: string;
}

export namespace HazardCategoryDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
